module.exports = __webpack_public_path__ + "static/img/docusing.6936052c.svg";